import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { AdminSidebar, AppLayout, Navbar, Flyout } from 'containers';
import { connect } from 'react-redux';
import * as styles from './LoggedOutLayout.scss';
var LoggedOutLayout = (_dec = connect(function (state) {
  return {
    user: state.auth.user,
    theme: state.theme
  };
}, {}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(LoggedOutLayout, _Component);

  var _super = _createSuper(LoggedOutLayout);

  function LoggedOutLayout() {
    _classCallCheck(this, LoggedOutLayout);

    return _super.apply(this, arguments);
  }

  _createClass(LoggedOutLayout, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          showBg = _this$props.showBg,
          showNavBar = _this$props.showNavBar,
          user = _this$props.user;
      var navBar = /*#__PURE__*/React.createElement("nav", {
        className: styles.nav
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.brand,
        style: {
          backgroundImage: "url(".concat(this.props.theme.logo, ")")
        }
      }));
      return /*#__PURE__*/React.createElement("div", {
        id: "LoggedOutLayout",
        className: styles.layout,
        style: showBg ? {
          backgroundColor: this.props.theme.colors.loggedOutBgColor
        } : {}
      }, showNavBar && navBar, this.props.children);
    }
  }]);

  return LoggedOutLayout;
}(Component), _defineProperty(_class2, "propTypes", {
  children: PropTypes.node.isRequired,
  showBg: PropTypes.bool,
  showNavBar: PropTypes.bool,
  user: PropTypes.object
}), _defineProperty(_class2, "defaultProps", {
  leftSidebar: null,
  rightSidebar: null,
  showBg: false,
  showNavBar: false
}), _temp)) || _class);
export default LoggedOutLayout;